export default {
  header: {
    menu: {
      home: 'Home',
      products: 'Products',
      solutions: 'Solutions',
      announcements: 'Official Announcements',
      contact: 'Contact Us'
    },
    submenu: {
      accountService: 'Account/Registration Services',
      accountServiceDesc: 'Resolve account opening failures or account restrictions',
      dataAnalysis: 'Data Analysis & Reporting',
      dataAnalysisDesc: 'Generate clear ad performance reports and analyze key metrics behind the data',
      adDesign: 'Ad Campaign Design & Setup',
      adDesignDesc: 'Customize ad strategies and provide detailed ad creation tutorials',
      adRejection: 'Ad Rejection Handling',
      adRejectionDesc: 'Guide clients in modifying ads, resubmitting for review, and navigating the appeal process',
      optimization: 'Optimization & Budget Allocation',
      optimizationDesc: 'Provide real-time optimization support and budget allocation tutorials for beginners',
      qa: 'Q&A',
      qaDesc: 'Provide 24/7 technical support for clients'
    },
    products: {
      kuamao: 'Cross-Border Shop',
      kuamaoDesc: 'Buy Outlook Emails | Buy Hotmail Emails | Wholesale Emails | Wholesale Twitter Accounts | Buy Overseas Emails | Wholesale Overseas Account Emails',
      eyou: 'EYOU',
      eyouDesc: 'Large Media Account Centralized Management System',
      card: "QHPay",
      cardDesc: "QHPay provides enterprise-level virtual card issuance and management services. Instantly generate unlimited Visa/Mastercard virtual cards to support advertising, SaaS subscriptions, and travel expenses, without the need for any physical cards."
    },
    kf: {
      telegram: 'Telegram Support',
      wechat: 'WeChat Support'
    },
    message: {
      stayTuned: 'Stay Tuned'
    }
  },
  home: {
    nav: {
      discuss: 'Explore with you',
      infinite: 'Infinite Possibilities of Overseas Marketing',
      experience: 'Experience Now'
    },
    intro: {
      title: 'We are an advertising company focused on overseas marketing, dedicated to providing cross-border marketing solutions for clients.',
      desc: 'We have extensive experience and a professional team, covering all categories, providing clients with rapid account opening and professional operation services, including comprehensive services on Facebook, Google, TikTok, Kwai, and many other overseas media platforms.'
    },
    carousel: {
      items: [
        { title: 'Do you need low-cost traffic acquisition but lack professional ad placement experience?' },
        { title: 'Do you need to use Facebook ads as a main sales channel and cover overseas markets?' },
        { title: 'Do you hope to quickly establish brand exposure and user base?' }
      ],
      contact: 'Contact Us'
    },
    coreBusiness: {
      title: 'Our Core Business',
      account: {
        title: 'Account Opening & Management',
        desc: 'Complete Facebook ad account creation and management for clients, including audit process handling and account opening material preparation guidance.'
      },
      strategy: {
        title: 'Ad Placement Strategy',
        desc: 'Help clients design ad campaigns, including budget allocation, targeting, and placement optimization.'
      },
      support: {
        title: 'Problem Solving Services',
        desc: 'Provide efficient after-sales support, answering common questions encountered during ad usage, such as account restrictions or ad rejections.'
      }
    },
    serviceScope: {
      title: 'Our Service Scope',
      card1: {
        title: 'Account/Registration Services',
        li1: 'Provide account opening material checklist (e.g., identity proof, business license, credit card info, etc.)',
        li2: 'Assist clients in submitting applications, ensuring materials meet Facebook audit requirements.',
        li3: 'Resolve account opening failures or account restrictions.'
      },
      card2: {
        title: 'Ad Campaign Design & Setup',
        li1: 'Customize ad strategies for clients, providing personalized suggestions based on business goals (e.g., brand exposure, traffic, sales conversion).',
        li2: 'Provide detailed ad creation tutorials, including objective selection, audience targeting, ad creative design, schedule planning, etc.'
      },
      card3: {
        title: 'Optimization & Budget Allocation',
        li1: 'Teach clients how to allocate budgets (e.g., low budget testing phase vs. high budget scaling phase).',
        li2: 'Provide real-time optimization support, such as adjusting audiences, creatives, or schedules based on data.'
      },
      card4: {
        title: 'Data Analysis & Reporting',
        li1: 'Generate clear ad performance reports for clients (e.g., CTR, conversion rate, impressions, etc.).',
        li2: 'Analyze key metrics behind the data, identify inefficient ads, and provide improvement suggestions.'
      },
      card5: {
        title: 'Ad Rejection Handling',
        li1: 'Analyze reasons for ad rejection (e.g., policy violation, image or text content violation).',
        li2: 'Guide clients to modify ads and resubmit for review.',
        li3: 'Provide appeal process guidance to quickly resolve issues.'
      },
      card6: {
        title: 'Q&A During Usage',
        li1: 'Provide 24/7 technical support for clients, solving account login, functional operation, or policy update issues.',
        li2: 'Develop FAQ library based on client feedback to improve service efficiency.'
      }
    },
    whyChoose: {
      title: 'Why Choose Us',
      connect: 'Contact Us',
      platform: {
        title: 'Multi-Platform Coverage',
        desc: 'Official Tier 1 media partners, including Facebook, Google, TikTok, Kwai, and other mainstream media platforms.'
      }
    },
    features: {
      custom: {
        title: 'Tailor-Made',
        subtitle: 'Professional Team',
        desc: 'We have an experienced and creative team, skilled in formulating overseas marketing strategies for different markets.'
      },
      precise: {
        title: 'Precision',
        subtitle: 'Operation Services',
        desc: 'We can precisely adjust and optimize your ad placement strategies to improve conversion rates and ROI.'
      },
      worryFree: {
        title: 'Worry-Free',
        subtitle: 'Service Guarantee',
        desc: 'We provide one-stop account opening and managed operation services, saving you time and energy.'
      }
    },
    footer: {
      partner: 'Official Partners',
      connect: 'Contact Us'
    }
  },
  kf: {
    telegram: 'Telegram Support',
    wechat: 'WeChat Support'
  },
  connect: {
    join: 'Time to Join\nBravotree Overseas Experts',
    try: 'Welcome to Try and Experience Deeply!',
    contact: 'Contact Us',
    exchange: 'Look Forward to Communicating with You',
    form: {
      name: 'Name',
      namePlaceholder: 'Enter your name',
      email: 'Email',
      emailPlaceholder: 'example@yourmail.com',
      surname: 'Surname',
      surnamePlaceholder: 'Enter your surname',
      company: 'Company Name',
      companyPlaceholder: 'Enter your full company name',
      telegram: 'Telegram',
      telegramPlaceholder: 'Tell us your Telegram account so we can understand you better...',
      submit: 'Submit',
      success: 'Submission Successful',
      error: 'Submission Failed',
      validName: 'Please enter your name',
      validEmail: 'Please enter your email',
      validEmailFormat: 'Please enter a valid email address',
      validSurname: 'Please enter your surname',
      validCompany: 'Please enter your company name',
      validTelegram: 'Please enter your Telegram account'
    }
  },
  announcement: {
    title: 'Scam Prevention Notice',
    content: 'Recently, some clients have encountered fraudulent activities such as fake ads, account deletion after payment, refusal to refund for various reasons, and scams imitating other service companies. To protect your rights, we issue this scam prevention notice.',
    tipsTitle: 'Anti-Scam Tips:',
    tips: [
      '1. Claiming <span>unrestricted</span> industries, anything can be advertised.',
      '2. Lack of knowledge about industry details and operational account specifics.',
      '3. Service fees <span>significantly lower</span> than the market average.',
      '4. Agreeing to all your requests without question.',
      '5. Trying to satisfy all your ideas to <span>induce</span> payment for ad placement.'
    ],
    normalProcessTitle: 'Normal Process',
    warning: [
      'Please be vigilant when choosing services to avoid being scammed.',
      'If you have any questions or need further information, please feel free to <span @click="openRandomLink()">contact us</span>.'
    ],
    process: [
      '<span>1.</span> Clients provide products and target regions; we evaluate suitable platforms or use client-requested platforms.',
      '<span>2.</span> We provide a summary of product risk control requirements for client decision-making.',
      '<span>3.</span> After confirming the placement plan, no prepayment is required; account audit comes first, payment is made only after audit approval.'
    ],
    menu: ['Official Announcements']
  },
  solution1: {
    nav: {
      oneStop: 'One-Stop',
      register: 'Ad Account Registration Service,',
      easyStart: 'Start Your Ad Journey Easily!',
      desc: 'Whether it\'s your first time advertising or you have some experience, our ad account registration service provides professional help. From preparing opening materials to resolving audit issues, we support you throughout the process to help you start advertising quickly.',
      btn: 'Experience Now'
    },
    modules: {
      num: '3',
      title: 'Major Service Modules',
      card1: {
        title: 'Material Preparation & Guidance',
        desc: 'We provide a detailed checklist for account opening materials to ensure you are fully prepared, and guide you on ensuring material completeness and compliance to avoid audit delays due to incomplete info.',
        link: 'Use Professional Archiving Service Now'
      },
      card2: {
        title: 'Professional Application Assistance',
        desc: 'We assist you in filling out application forms, uploading all necessary documents, and ensuring submitted information meets platform requirements. This helps avoid audit issues due to inaccurate or incomplete materials.',
        link: 'We Ensure Your Submission Success'
      },
      card3: {
        title: 'Quick Account Issue Resolution',
        desc: 'If your account is rejected or frozen during the audit, we provide professional technical support to find the root cause and offer solutions. We ensure smooth approval and account activation upon resubmission.',
        link: 'Use Our Professional Activation Service'
      }
    },
    faq: {
      title: 'FAQ',
      q1: 'Q: Why did my account audit fail?',
      a1: 'A: Audit failure is usually due to incomplete materials or non-compliance with platform requirements. We will analyze the failure reason and help you modify and resubmit.',
      q2: 'Q: How long does account opening take?',
      a2: 'A: Generally, platform audit takes 1-3 working days. We will track the progress and inform you of the results in time.',
      q3: 'Q: How to avoid account freezing or banning?',
      a3: 'A: We provide detailed account management guidance to help you avoid common violations and ensure account safety.'
    }
  },
  solution2: {
    content1: {
      title1: 'Data-Driven Ad Operation',
      title2: 'Full Optimization Support',
      desc: 'Through professional ad data analysis and report interpretation, we provide clear ad performance insights, identify optimization opportunities precisely, and help clients achieve higher ad ROI.',
      btn: 'Experience Now'
    },
    content2: {
      title: 'Phased Ad Data Analysis',
      desc: 'Through low-budget testing, analyze audience feedback and ad performance to screen optimal strategies, concentrate resources on high-efficiency ad campaigns, while continuously optimizing details to expand coverage and influence.',
      card1: 'Testing Phase Assessment',
      card2: 'Maturity Phase Assessment',
      btn: 'Start Assessment'
    },
    content3: {
      title: 'Comprehensive Reporting & Insights',
      desc: 'Multi-dimensional metric analysis, audience persona insights, industry benchmarking<br />Making ad placement more scientific and efficient'
    },
    content4: {
      title: 'Precise Optimization Action Plan',
      desc: 'Behind ad performance lies a wealth of optimization info worth digging into<br />We help clients interpret data to discover problems and opportunities',
      item1: {
        title: 'Data-Driven Creative Improvement',
        desc: 'Update creative assets based on user interaction data to improve ad attractiveness.'
      },
      item2: {
        title: 'Placement Path Optimization',
        desc: 'Analyze user behavior paths after clicking ads to optimize landing page conversion effects.'
      },
      item3: {
        title: 'Budget & Channel Adjustment',
        desc: 'Flexibly allocate budgets, prioritizing high-efficiency ad campaigns and reducing inefficient spending.'
      }
    }
  },
  solution3: {
    content1: {
      title1: 'Tailor-Made For Your Brand',
      title2: 'Precise Ad Campaigns',
      desc: 'We provide comprehensive ad campaign design and setup services, combining data analysis and industry experience to help your brand stand out in fierce market competition.',
      btn: 'Experience Now'
    },
    content2: {
      title: 'Every successful ad placement relies on<br/>scientific strategy and precise execution',
      desc: 'We will provide you with fully customized ad strategies<br/>ensuring ad campaigns align closely with your business goals',
      items: [
        { text: 'Brand Exposure<br/>Enhance influence, cover target audience' },
        { text: 'Traffic Generation<br/>Precision, attract quality traffic' },
        { text: 'Sales Conversion<br/>Optimize creatives & data, boost conversion rates' },
        { text: 'Audience Targeting<br/>Precisely lock in customer groups' },
        { text: 'Creative Optimization<br/>Provide high-quality assets, enhance appeal' },
        { text: 'Placement Planning<br/>Reasonably arrange budget and schedule' }
      ]
    },
    content3: {
      title: 'We help you continuously optimize ad performance',
      items: [
        { title: 'Ad Data Analysis', desc: 'Periodically analyze key metrics like CTR, conversion rate, ROI to ensure quantifiable ad effects.' },
        { title: 'A/B Testing', desc: 'Continuously conduct A/B testing to choose the best performing ad assets and strategies for sustained improvement.' },
        { title: 'Real-Time Adjustment', desc: 'Our team adjusts strategies in real-time based on ad placement data to ensure continuous optimization.' }
      ]
    }
  },
  solution4: {
    content1: {
      title: 'Ad Rejection Handling Service',
      desc: 'We are well-versed in the audit rules and policies of major ad platforms. Whether rejected due to policy reasons<br/>or needing appeal support, we can provide professional guidance.',
      btn: 'Experience Now'
    },
    content2: {
      title: 'Comprehensive Compliant Ad Rectification Service',
      desc: 'Rejected ads do not mean the end of marketing, but an opportunity for optimization<br/>We will provide improvement suggestions based on rejection reasons and guide clients to optimize ad content',
      item1: {
        btn: 'Violation Type Judgment',
        desc: 'We will deeply analyze the specific reasons behind<br/>ad rejection',
        title: 'Precise Diagnosis of Rejection Reasons',
        list: [
          'Detailed analysis of ad rejection feedback reports to identify major violation reasons (content, technical, or industry policy issues).',
          'Provide personalized policy interpretation to help clients fully understand platform audit rules.'
        ]
      },
      item2: {
        title: 'Full Appeal Process Guidance',
        list: [
          'Assist clients in submitting appeal materials through ad platform channels.',
          'Follow up on appeal progress and maintain effective communication with the platform audit team.'
        ],
        btn: 'Contact Support'
      },
      item3: {
        title: 'Fast Audit Support',
        list: [
          'Assist clients in completing the resubmission process after ad rectification, tracking audit progress to ensure quick approval.',
          'Provide full-process tracking support for rectified ads.'
        ],
        btn: 'Experience Now'
      }
    }
  },
  solution5: {
    nav: {
      title: 'Optimization & Budget Allocation',
      subtitle: 'Make Ad Performance',
      highlight: 'Clear at a Glance',
      desc: 'Still worried about how to allocate ad budgets or poor placement results? Let us help! Through scientific budget allocation and real-time optimization strategies, we help your ads be more efficient and worry-free.',
      btn: 'Experience Now'
    },
    content2: {
      title: 'How to make ad budgets more efficient?',
      item1: {
        title: 'Precise Testing Phase',
        desc: 'Through low-budget testing, screen excellent ad strategies and audience groups to quickly find the best ad combination. The goal of the testing phase is to explore the best ad combination at the lowest cost, avoiding ineffective spending and laying a solid foundation for subsequent large-scale placement.'
      },
      item2: {
        title: 'Maturity Phase Expansion',
        desc: 'After the testing phase, enter the maturity stage of ad placement. The focus now is to expand coverage, optimize budget allocation, and maximize conversion effects. Through precise strategies and deep optimization in this stage, enterprises can maximize ad influence, attract more potential customers, and drive comprehensive sales conversion improvements.'
      }
    },
    content3: {
      title: 'Take Ad Performance to the Next Level',
      subtitle: 'Precisely Master Core Ad Data',
      connect: 'Contact Us',
      item1: {
        title: 'Precise Audience Optimization',
        desc: 'Audience targeting is the core of ad success. By precisely optimizing target groups, ad reach and conversion efficiency can be significantly improved. Through precise audience optimization, ads can not only reach core users but also effectively tap into potential customer groups.'
      },
      items: [
        { title: 'Real-Time Data Analysis', desc: 'Real-time data analysis is the starting point of ad optimization and the key to ensuring ads always perform efficiently.' },
        { title: 'Creative Iteration', desc: 'Ad creative is the first step to attracting user attention. As market competition intensifies, only by continuously optimizing ad content can user interest and interaction willingness be maintained.' },
        { title: 'Time & Budget Sync Adjustment', desc: 'Time and budget are the most important resources in ad placement. We scientifically allocate resources by dynamically adjusting placement time and budget allocation.' }
      ]
    }
  },
  solution6: {
    nav: {
      highlight: '24/7',
      title: 'Technical Support',
      subtitle: 'Solve Problems Easily',
      desc: 'Our technical team provides 7x24 all-round support services to solve various problems you encounter during use at any time.',
      btn: 'Contact Us'
    },
    content1: {
      title: 'Q&A Service During Usage',
      desc: 'Whether it is login difficulties, functional usage doubts, or policy update troubles<br/>We will provide you with all-round support',
      item1: {
        title: 'How to Contact Us?',
        desc: 'Let us escort your ad placement, solve all usage problems,<br/>and make your business run more efficiently and smoothly!',
        btn: 'Click to Contact Us'
      },
      item2: {
        title: 'FAQ Library Construction to Improve Efficiency',
        desc: 'Through the FAQ library, clients can quickly find solutions to common problems without waiting, significantly improving service efficiency and client experience',
        btn: 'Click to Use'
      }
    }
  }
}
